import {QuestionBase} from "./question-base";

export class ImagesBox extends QuestionBase<string> {
  override controlType = 'imagesbox';
}
